import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";
import { GET_TOKEN_HEADER, useGetCommunicationToken } from "src/networking";
import { usePostSendDossier } from "src/networking/terminals/signature/signature.gates";
import { useCurrentStepStore } from "src/storage/formik/formik-current-step.store";
import {
  useDraftCAIStore,
  useDraftIDStore,
} from "src/storage/formik/formik-draft.store";
import { SendDossierRequestBodyDTO } from "src/types";
import "./signature-result.scss";

export const useSignatureResult = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const code = searchParams.get("code");
  const status = searchParams.get("status");
  const draftId = searchParams.get("idBozza");
  const encodedEmailB = searchParams.get("email");

  const { crossGate: postSendDossier } = usePostSendDossier();
  const { crossGate: getCommunicationToken } = useGetCommunicationToken();

  const resetDraftId = useDraftIDStore((state) => state.resetDraftID);
  const resetDraft = useDraftCAIStore((state) => state.resetDraft);
  const resetCurrentStep = useCurrentStepStore(
    (state) => state.resetCurrentStep,
  );

  const storeEmail = useDraftCAIStore(
    (state) => state.draft.vehicleA.driver.email,
  );

  const [mainEmail, setMainEmail] = useState<string>(
    storeEmail?.toLowerCase() || "",
  );

  const emailB = useMemo(() => {
    return encodedEmailB ? decodeURIComponent(encodedEmailB).toLowerCase() : "";
  }, [encodedEmailB]);

  const emailToShow = mainEmail || emailB;

  const sendDossier = () => {
    if (!draftId) return;

    const body: SendDossierRequestBodyDTO = {
      idRichiesta: draftId,
    };

    postSendDossier(
      { body },
      {
        onSuccess: () => {},
      },
    );
  };

  const getEmail = async () => {
    if (!code) return;

    await getCommunicationToken(
      {
        headers: GET_TOKEN_HEADER,
        uriParams: { code },
      },
      {
        onSuccess: (response) => {
          const { email } = response.data;
          if (email) {
            setMainEmail(email.toLowerCase());
          }
        },
        onFailure: (err) => {
          console.error("Error fetching email:", err);
        },
      },
    );
  };

  const resetData = () => {
    resetDraftId();
    resetDraft();
    resetCurrentStep();
  };

  useEffect(() => {
    if (status === "OK") {
      sendDossier();
      resetData();
    }
  }, [status]);

  useEffect(() => {
    if (code && !emailB) {
      getEmail();
    }
  }, [code, emailB]);

  return {
    status,
    emailToShow,
    emailB,
    showEmailB: !!emailB,
    t,
    navigate,
  };
};
